import { useMemo } from 'react';
import { CaseSummary } from './types';
import { StatusFilterValue } from './TabShell';

/**
 * Shared search + status filter used by all three accountant tabs.
 * Extracted verbatim from pages/AccountantQueue.tsx during Task 4.
 */
export function useCaseFilter(
  cases: CaseSummary[],
  searchQuery: string,
  statusFilter: StatusFilterValue,
): CaseSummary[] {
  return useMemo(() => {
    return cases.filter((c) => {
      if (searchQuery) {
        const q = searchQuery.toLowerCase();
        const matches =
          (c.business_name || '').toLowerCase().includes(q) ||
          (c.client_name || '').toLowerCase().includes(q) ||
          (c.law_firm || '').toLowerCase().includes(q) ||
          (c.event_type || '').toLowerCase().includes(q);
        if (!matches) return false;
      }
      if (statusFilter !== 'all') {
        // 2026-04-30: aligned with AccountantCaseRow.canSignOff — the
        // backend's `is_ready_for_review` is the canonical SSoT for "ready",
        // legacy `case_strength>=70` / `assigned_queue==='ready'` are
        // additive fallbacks. Without this, the "Ready" filter chip would
        // exclude cases the backend has positively marked ready (the d6d88aea
        // repro case had is_ready_for_review=true but case_strength=42).
        if (
          statusFilter === 'ready' &&
          c.is_ready_for_review !== true &&
          c.assigned_queue !== 'ready' &&
          c.case_strength < 70
        )
          return false;
        if (statusFilter === 'stale' && c.days_stale < 5) return false;
        if (
          statusFilter === 'needs-review' &&
          c.transactions_need_review === 0 &&
          c.completion_percentage >= 90
        )
          return false;
      }
      return true;
    });
  }, [cases, searchQuery, statusFilter]);
}
